import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_AffinitySet_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_AFFINITYSET_ID:              {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Affinity Set Id',        columnResourceName: 'colId',                      alignment: HorizAlignment.Left},  domainOptions: {} },
    AFFINITYSET_ID:                 {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Affinity Set Id',           columnResourceName: 'colAffinitySetId',           alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    AFFINITYSET_NAME:               {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Affinity Set Name',         columnResourceName: 'colAffinitySetName',         alignment: HorizAlignment.Left},  domainOptions: {maxLength: 256}},
    CANNIBALIZATION_TYPE_ID:        {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Cannibalization Type Id',   columnResourceName: 'colCannibalizationTypeId',   alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CANNIBALIZATION_TYPE_NAME:      {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Cannibalization Type Name', columnResourceName: 'colCannibalizationTypeName', alignment: HorizAlignment.Left},  domainOptions: {maxLength: 256}},
    CUSTOMER_LEVEL_ID:              {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer Level',            columnResourceName: 'colCustomerLevel',           alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50, domainIds: "Customer_Type", useIdAsKey: true}},
    PRODUCT_LEVEL_ID:               {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Level',             columnResourceName: 'colProductLevel',            alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50, domainIds: "ProductGroup_Level", useIdAsKey: true}},
    MANUAL_IND:                     {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Manual',                   columnResourceName: 'colManual',                  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 1}},
    CUSTOMER_CANN_METHOD:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Customer Cann. Method',     columnResourceName: 'colCustomerCannMethod',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50, domainIds: "CustomerCannibalizationMethod", useIdAsKey: true}},
    PRODUCT_CANN_METHOD:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Product Cann. Method',      columnResourceName: 'colProductCannMethod',       alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50, domainIds: "ProductCannibalizationMethod", useIdAsKey: true}},
    TIME_CANN_METHOD:               {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Time Cann. Method',         columnResourceName: 'colTimeCannMethod',          alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50, domainIds: "TimeCannibalizationMethod", useIdAsKey: true}},
    GROUP_COUNT:                    {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Group Count',              columnResourceName: 'colGroupCount',               alignment: HorizAlignment.Left}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
};

const AffinitySetSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_AFFINITYSET_ID',
                id_ui: 'AFFINITYSET_ID',
                name:  'AFFINITYSET_NAME'},

    searchProviderFields: vUI_AffinitySet_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_AffinitySet',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const AffinitySetSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "AffinitySetSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id',   searchProviderFieldId: 'AFFINITYSET_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'AFFINITYSET_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'AFFINITYSET_ID', 'AFFINITYSET_NAME', 'CANNIBALIZATION_TYPE_NAME', 'GROUP_COUNT', 'CUSTOMER_LEVEL_ID', 'PRODUCT_LEVEL_ID','CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: AffinitySetSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const AffinitySetSearch: ISearch = {
    searchName: "Find Affinity Set",
    renderOptions: {ui5ResourceId: "AffinitySetSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [AffinitySetSearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("AffinitySetBO", "AffinitySet", AffinitySetSearch, "Affinity Set Search")

export {AffinitySetSearch}

